export default function() {
    return {
        boosts: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {

        },
        idTrip: null,
        search: {},
        fields: [
            {
                key: 'description',
                label: 'Descrição'
            },
            {
                key: 'agency',
                label: 'Agência'
            },
            {
                key: 'timestamp',
                label: 'Data'
            },
            {
                key: 'actions',
                label: ''
            }
        ]
    }
}
